var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('n-list',{attrs:{"value":"shops","text":"分店","fields":_vm.fields,"items":_vm.shops}})}
var staticRenderFns = []

export { render, staticRenderFns }